var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrow = function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "left-arrow_svg__a",
    d: "M0 0h44v44H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6,
    transform: "rotate(90 22 23)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "left-arrow_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#left-arrow_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#left-arrow_svg__a",
    fill: "#FFF",
    stroke: "#DDD"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M28.998 11 30 27l-16-1.002",
    mask: "url(#left-arrow_svg__b)",
    transform: "rotate(45 22 19)"
  }))));
};
export default SvgLeftArrow;